import {Component, OnInit} from '@angular/core';
import {BaseHttpService} from '../../../../services/base-http/base-http.service';
import {AreaService} from '../../../../services/area/area.service';
import {OfferComponent} from '../offer.component';

@Component({
  selector: 'app-mini-map',
  templateUrl: './minimap.component.html',
  styleUrls: ['./minimap.component.scss']
})
export class MinimapComponent implements OnInit {
  
  constructor(public httpService: BaseHttpService, public areaService: AreaService, public offerComponent: OfferComponent) {
  }
  
  ngOnInit() {
  }
  
  selectOfferAreaOnMiniMap(id: string): boolean {
    return this.areaService.areas.find((area) => area.id === id).name === this.offerComponent.selectedOffer.area.valueBg;
  }
}
